import {API_URL} from "../settings/local_settings";
import {APIClient} from "./APIClient";

export class AccessService {
    static MODULE_MARKETING = "MARKETING";
    static MODULE_MANAGE_ACCOUNTS = "MANAGE_ACCOUNTS";
    static MODULE_TEAM = "TEAM";
    static MODULE_SHEETS_SYNC = "SHEETS_SYNC";
    static MODULE_DATA_EXPLORER = "DATA_EXPLORER";
    static MODULE_AGENT = "AGENT";
    static MODULE_REPORTS = "REPORTS";
    static MODULE_ACCESS_CONFIGURATION = "ACCESS_CONFIGURATION"
    static MODULE_INSIGHTS = "INSIGHTS"
    static MODULE_ACTIVITY_LOG = "ACTIVITY_LOG"
    static MODULE_DASHBO_MCP = "DASHBO_MCP"

    static GetUserModulesUrl(userId) {
        return API_URL + `user/${userId}/access/modules`;
    }

    static GetUserModules(userId, handlerOnSuccess, handlerOnError=null) {
        new APIClient(AccessService.GetUserModulesUrl(userId)).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                if(handlerOnError)
                    handlerOnError(data);
                else
                    alert(data['error_message']);
            } else if (data.status === 'OK') {
                handlerOnSuccess(data.data)
            }
        })
    }
}
